export const headerFontColor = '#5E5F61'
export const editContainerFontColor = '#211F20'
export const dragIconColor = '#C9C9C9'

export const blueButtonMainColor = '#13B5EA'
export const blueButtonBorderColor = '#0069AA'
export const blueButtonBGColor = 'rgba(19, 181, 234, 0.25)'
export const blueButtonBorderStyle = `1px solid ${blueButtonBorderColor}`

export const closeButtonBGColor = '#04797C'
export const closeButtonHoveredColor = '#036063'

export const masterPrimary = '#10B091'
